

















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfigsService from "@/services/api/configs.service";
import {
  ActivityTypeDto,
  ActivityStatusDto,
  ActivityPriorityDto,
  LanguageDto,
  ActivityAreaDto
} from "@/server/app.dtos";

@Component
export default class ActivitiesMenuList extends Vue {
  @Prop() activityArea!: ActivityAreaDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  @Watch("activityArea", { deep: true })
  onActivityAreaChanged() {
    this.Load();
  }
  @Watch("currentTypeId")
  @Watch("currentStatusId")
  @Watch("currentPriorityId")
  onChanged() {
    if (this.ignoreRender) {
      this.ignoreRender = false;
      return;
    }
    const p = Object.assign({}, this.$route.query, {
      skip: 0,
      idActivityType: this.currentTypeId,
      idActivityStatus: this.currentStatusId,
      idActivityPriority: this.currentPriorityId
    });
    this.$router.push({ query: p });
  }
  configsService: ConfigsService = new ConfigsService();
  status: ActivityStatusDto[] = [];
  types: ActivityTypeDto[] = [];
  priorities: ActivityPriorityDto[] = [];

  ignoreRender: boolean = true;
  currentTypeId: number | null = null;
  currentStatusId: number | null = null;
  currentPriorityId: number | null = null;

  async created() {
    await this.Load();
  }

  async Load() {
    let query: string = "IdLanguage=" + this.currentLanguage.idLanguage;
    if (this.activityArea != null) {
      query += "&IdActivityArea=" + this.activityArea.idActivityArea;
    }

    await this.configsService
      .Load("api/activitystatus", query)
      .then(result => (this.status = result));

    await this.configsService
      .Load("api/activitytypes", query)
      .then(result => (this.types = result));

    await this.configsService
      .Load(
        "api/activitypriorities",
        "IdLanguage=" + this.currentLanguage.idLanguage
      )
      .then(result => (this.priorities = result))
      .finally(() => {
        if (this.$route.query) {
          const q = this.$route.query;
          if (q.idActivityType) {
            this.currentTypeId = parseInt(q.idActivityType as string);
          }
          if (q.idActivityStatus) {
            this.currentStatusId = parseInt(q.idActivityStatus as string);
          }
          if (q.idActivityPriority) {
            this.currentPriorityId = parseInt(q.idActivityPriority as string);
          }
        }
      });
  }
}
